/**
 * @export
 * @class CallWeb
 * callweb 관리
 */

export default class CallWeb {
  /**
   * 딜상세에서 카트담기 완료 후 app에서 보내주는 callback,
   * 카트담기가 완료되면 선택한 옵션을 리셋한다.
   * @param bSuccess
   */
  completeAddToCart = sSuccess => {
    TMON.bIsAvailAddToCart = true;
    if (!sSuccess) {
      return;
    }

    if (TMON.app.checkVersion('6.3.0') >= 0) {
      TMON.oApp.oCartManager.showCartPopup();
    }
    // 카트 담기 성공 이후 카트 아이템 비움
    // isAvailableOptionSelect 가 true 일 때 비움 (option selector 사용 가능할 때만 비움)
    if (TMON.oApp.htStorage.optionInfo.isAvailableOptionSelect) {
      TMON.oApp.setStorage('innerCartItems', {
        sAction: 'initialize',
        aList: [],
      });
    }
  }

  /**
   * 앱에서 로그인 한 후 처리
   * @param bLogin {Boolean} 로그인 여부
   */
  afterLogin = bSuccess => {
    if (TMON.view_mode === 'app' && TMON.app_os === 'ios' && bSuccess) {
      window.location.reload();
    }
  }

  /**
   * 찜하기 탭간 연동
   */
  refreshZzim = () => {
    const htGetDealInfo = TMON.oApp.oApi.getApiInfo('getDibsInfo');
    const htGetPartnerInfo = TMON.oApp.oApi.getApiInfo('getDibsInfo', {
      dibsType: 'PARTNER',
    });
    const dealUrl = `${htGetDealInfo.callParam.url}?${$.param(
      htGetDealInfo.callParam.params
    )}`;
    const partnerUrl = `${htGetPartnerInfo.callParam.url}?${$.param(
      htGetPartnerInfo.callParam.params
    )}`;
    const welDealZzimElements = $('[data-zzim=deal]');
    const welPartnerZzimElements = $('[data-zzim=partner]');

    [
      {
        zzim: TMON.oApp.oZzim.dealZzim,
        url: dealUrl,
        elements: welDealZzimElements,
      },
      {
        zzim: TMON.oApp.oZzim.partnerZzim,
        url: partnerUrl,
        elements: welPartnerZzimElements,
      },
    ].forEach(({ zzim, url, elements }) => {
      $.ajax({
        url,
        success: res => {
          if (!res.data.alreadyDibsItem) {
            Array.from(elements).forEach(el => {
              zzim.toggleZzimState(false, el, res.data.formatCount);
            });
          }
        },
      });
    });
  }

  /**
   * 모바일에서 사용자 캡쳐 액션시 공유하기 유도 말풍선 띄우기
   */
  captureEventOccured = () => {
    if (
      TMON.oApp.oShareCapture &&
      typeof TMON.oApp.oShareCapture.showToast === 'function'
    ) {
      TMON.oApp.oShareCapture.showToast();
    }
  }
}